import { JWTService } from '@/shared/services/jwt'
import ClientFactory from '@/shared/factories/client'
import redirecionaSemSessao from './redirecionaSemSessao'

const APIClient = ClientFactory.New(
  process.env.APIBaseURLAccess,
  { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
)

// Dev: enviar Bearer do localStorage — fluxo de login local
// Prod/aceite: sem Bearer — cookie zcloud_token enviado via withCredentials
if (process.env.NODE_ENV === 'development') {
  APIClient.interceptors.request.use((request) => {
    const token = JWTService.GetToken()

    /* eslint-disable-next-line */
    if (token) request.headers.Authorization = `Bearer ${token}`

    return request
  }, error => Promise.reject(error))
}

APIClient.interceptors.response.use(response => response, redirecionaSemSessao)

export default APIClient



// WEBPACK FOOTER //
// ./src/shared/http/clients/api.js